import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const PartnerUniAmericaSlider = (props) => {

    const settings = {
        dots: false,
        infinite: true,
        speed: 750,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        responsive: [
            {
              breakpoint: 1172,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 756,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 2,
                initialSlide: 2
              }
            },
            {
              breakpoint: 530,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
                breakpoint: 350,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
          ]
      }

    return (
        <div className='row'>
          <div className="col-12">
            <h3 className='text-center'> Featured Partner Universities </h3>
          </div>
          <div className="col-12">
            <Slider {...settings}>
              <img className="partner-uni-america-slider-image" src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/1.png" />
              <img className="partner-uni-america-slider-image" src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/12.png" />
              <img className="partner-uni-america-slider-image" src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/6.png" />
              <img className="partner-uni-america-slider-image" src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/2.png" />
              <img className="partner-uni-america-slider-image" src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/10.png" />
            </Slider>
          </div>
        </div>
    )
}

export default PartnerUniAmericaSlider
